import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import OfferGallery from '../components/OfferGallery'

const OfferGalleryContainer = ({ images, badge }) => {
  const { t } = useTranslation()

  return (
    <OfferGallery
      showMore={t('common:gallery.showMore')}
      images={images}
      badge={badge}
    />
  )
}

export default OfferGalleryContainer
